export enum AuthError {
  userNotConfirmedException = 'UserNotConfirmedException',
  passwordResetRequiredException = 'PasswordResetRequiredException',
  notAuthorizedException = 'NotAuthorizedException',
  userNotFoundException = 'UserNotFoundException',
  invalidPasswordException = 'InvalidPasswordException',
  codeDeliveryFailureException = 'CodeDeliveryFailureException',
  limitExceededException = 'LimitExceededException',
  codeMismatchException = 'CodeMismatchException',
  expiredCodeException = 'ExpiredCodeException',
  invalidParameterException = 'InvalidParameterException',
}
